import { constant, pipe } from "fp-ts/lib/function";
import { Language } from "../models/language";
import { Failure } from "./failure";
import { option } from "fp-ts";
import number from "fp-ts-std/Number";

export class DOMValueExtractor {
  root: Element;
  constructor(root: Element = document.documentElement) {
    this.root = root;
  }

  private getBaseUrl(): string {
    const apiLink =
      this.root
        ?.querySelector('link[rel="https://api.w.org/"]')
        ?.attributes?.getNamedItem("href")?.value ?? Failure("No API link");

    return new URL(apiLink).origin + "/wp-json/";
  }

  private getLanguage(): Language {
    let langVal = this.root.getAttribute("lang");
    return langVal == "en-US" ? "en-US" : "da-DK";
  }

  getExhibitionId(): string {
    // try to get from the ug element
    // try to get from global
    // else fail
    const maybeExhibitionIdFromElement = pipe(
      this.root.querySelector(".ug[data-exhibition-id]"),
      option.fromNullable,
      option.flatMap((e) =>
        pipe(e.getAttribute("data-exhibition-id"), option.fromNullable)
      )
    );
    const maybeExhibitionIdFromGlobalJsVar = () =>
      typeof exhibitionID == "undefined"
        ? option.none
        : option.some(exhibitionID);

    const ExhibitionIdOrFailure = pipe(
      maybeExhibitionIdFromElement,
      option.orElse(maybeExhibitionIdFromGlobalJsVar),
      option.getOrElseW(() => Failure("Missing exhibition ID"))
    );

    return ExhibitionIdOrFailure;
  }

  static getBaseUrl(): string {
    return new DOMValueExtractor().getBaseUrl();
  }

  static getLanguage(): Language {
    return new DOMValueExtractor().getLanguage();
  }

  static getExhibitionId(): string {
    return new DOMValueExtractor().getExhibitionId();
  }
}
